
export default {
    DISPLAY_HEIGHT: 600,
    DISPLAY_WIDTH: 800,
    DISPLAY_COLOUR: "#dfdfdf",
    DEBUG: true,
    LOCALE: "en-GB",
    TRIGGER_RATE: 500,  // milliseconds between trigger tests
    SPRITE_RATE: 40,    // milliseconds between sprite updates
    CLEANUP_RATE: 960,  // milliseconds between adjustable clean up
    VOLUME_MIN: 0,
    VOLUME_MAX: 100,
    GRAVITY_PS2: 10,   // force of gravity in pixels per second per second
    BOUNDS_X: 2,        // Multiplier for display width for bounds checking
    BOUNDS_Y: 2,        // Multiplier for display height for bounds checking
    DEPTH_BACKGROUND: 50,
    DEPTH_SKY: 100,
    DEPTH_GROUND: 200,
    DEPTH_LEFT: 300,
    DEPTH_RIGHT: 301,
    DEPTH_FOREGROUND: 400,
    DEPTH_FRAME: 1000,
    LOOP_MAXIMUM: 1000, // greatest number of times we allow a loop to run
    CITY: "London",
    LAT: 52,
    LON: 0,
    // If you provide a CORS proxy please include the arguments
    // CORS_PROXY: 'https://cors-anywhere.herokuapp.com/corsdemo?',
    CORS_PROXY: "",
};
